import { createSlice } from "@reduxjs/toolkit";

export type TokenSliceType = {
  value: string | null;
};

export const tokenSlice = createSlice({
  name: "token",
  initialState: {
    value: null,
  } as TokenSliceType,
  reducers: {
    setToken: (state, action: { payload: string; type: string }) => {
      state.value = action.payload;
    },
    removeToken: (state, action) => {
      state.value = null;
    },
  },
});

export const { setToken, removeToken } = tokenSlice.actions;

export default tokenSlice.reducer;
